import { FunctionComponent, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import StandardButton from 'design-system/Buttons/StandardButton'

import StyledHr from 'components/GlobalStyles/Hr'
import Spacer from 'components/Spacer'

import BathRangeInput from '../SelectionInputs/BathRangeInput'
import BedRangeInput from '../SelectionInputs/BedRangeInput'
import ForSaleTypeSelectionInput from '../SelectionInputs/ForSaleTypeSelectionInput'
import { IBathProps, IBedProps, IForSaleTypeProps, IMobileSheetProps } from '../types'
import MobileFilterSheet from './Shared/MobileFilterSheet'

const Container = styled.div`
  height: 100%;
`

const BottomRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

interface IProps {
  forSaleTypeProps: IForSaleTypeProps
  bedProps: IBedProps
  bathProps: IBathProps
  onApply: () => void
  onReset: () => void
}

const MoreFiltersMobileSheet: FunctionComponent<IProps & IMobileSheetProps> = ({
  forSaleTypeProps,
  bedProps,
  bathProps,
  onApply,
  onReset,
  visible,
  showMobileFilterSheet,
  hideMobileFilterSheet,
}) => {
  const theme = useContext(ThemeContext)

  const [errors, setErrors] = useState<{ [key: string]: string }>({})

  const setBedError = (error: string) => setErrors({ ...errors, bed: error })

  const setBathError = (error: string) => setErrors({ ...errors, bath: error })

  const setVisible = (newVisible: boolean) => {
    if (newVisible) showMobileFilterSheet()
    else hideMobileFilterSheet()
  }

  const handleClickApply = () => {
    onApply()
    hideMobileFilterSheet()
  }

  const handleClickReset = () => {
    onReset()
    hideMobileFilterSheet()
  }

  return (
    <MobileFilterSheet
      height={510}
      visible={visible}
      setVisible={setVisible}
      onClose={hideMobileFilterSheet}
    >
      <Container>
        <ForSaleTypeSelectionInput {...forSaleTypeProps} />
        <Spacer size={theme.spacings[24]} />
        <StyledHr color="neutral200" />
        <Spacer size={theme.spacings[24]} />
        <BedRangeInput
          {...bedProps}
          onError={setBedError}
        />
        <Spacer size={theme.spacings[24]} />
        <StyledHr color="neutral200" />
        <Spacer size={theme.spacings[24]} />
        <BathRangeInput
          {...bathProps}
          onError={setBathError}
        />
        <Spacer size={theme.spacings[24]} />
        <BottomRow>
          <StandardButton
            type="primary"
            label="Apply"
            size="medium"
            onClick={handleClickApply}
            fullWidth
          />
          <Spacer size={theme.spacings[4]} />
          <StandardButton
            type="tertiary"
            label="Reset"
            size="small"
            onClick={handleClickReset}
            fullWidth
          />
        </BottomRow>
      </Container>
    </MobileFilterSheet>
  )
}

export default MoreFiltersMobileSheet
